// Small text helpers shared by detail pages (VOD01, VOD02). Owner: WP04.
import { Link } from 'react-router';

/** "2025 · PG-13 · 1h 48m" from known values only; falsy parts are dropped, never guessed. */
export function dotJoin(parts: (string | number | null | undefined | false)[]): string {
  return parts.filter((p) => p !== null && p !== undefined && p !== false && p !== '').join(' · ');
}

/** Metadata line; renders nothing when no part is known. */
export function MetaLine({ parts, className = 'ui-meta' }: { parts: (string | number | null | undefined | false)[]; className?: string }) {
  const text = dotJoin(parts);
  return text ? <p className={className}>{text}</p> : null;
}

export function Breadcrumb({ parent, parentTo, title }: { parent: string; parentTo: string; title: string }) {
  return (
    <nav aria-label="Breadcrumb" className="ui-crumbs">
      <ol>
        <li><Link to={parentTo}>{parent}</Link></li>
        <li aria-current="page">{title}</li>
      </ol>
    </nav>
  );
}
